export default "__VITE_ASSET__a11b7455__"